import { createContext, useContext } from 'react';

import { RouteTrackerContextType } from './routeTrackerContextType';

export const RouteTrackerContext = createContext<{
    history: RouteTrackerContextType[];
    pushToHistory: (x: RouteTrackerContextType) => void;
    popFromHistory: () => void;
}>({
    history: [],
    pushToHistory: () => null,
    popFromHistory: () => null,
});

RouteTrackerContext.displayName = 'RouteTracker';

export const useRouteTracker = () => {
    return useContext(RouteTrackerContext);
};
